/**
 * London Smoke & Cure — Njord RTDB (same Auth as wholesale default app).
 *
 * Uses getDatabase(defaultApp, rtdbUrl) so the signed-in operator token (admin claim) applies.
 */

import { getDatabase } from 'firebase/database';
import { app } from '../firebase';
import { getNjordRtdbUrl } from './njordConfig';

let njordDb = null;

export function getNjordDatabase() {
    const url = getNjordRtdbUrl();
    if (!url) return null;
    if (njordDb) return njordDb;
    njordDb = getDatabase(app, url);
    return njordDb;
}

/** Reset cached instance (tests or hot reload). */
export function resetNjordDatabaseForTests() {
    njordDb = null;
}
